import { useQuery } from "@tanstack/react-query";
import { department } from "./query";
import { PostModel } from "common/models/BaseModel";
import { IDepartmentGridFilter } from "./types";

export function GetDepartments(
  model: PostModel<IDepartmentGridFilter> | undefined
) {
  return useQuery(department.list(model));
}

export function GetDepartment(Id: string | number) {
  return useQuery({
    ...department.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetDepartmentValues() {
  return useQuery(department.getDepartmentValues());
}

export function GetDepartmentValuesWithInstituteCode(id: string | number) {
  return useQuery({
    ...department.getDepartmentValuesWithInstituteCode(id),
    refetchOnMount: true,
    enabled: Boolean(id),
  });
}

export function GetDepartmentView(id: string | number, isOpen: boolean) {
  return useQuery({
    ...department.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}

export function GetDepartmentValuesByInstitute(Id: string | number) {
  return useQuery({
    ...department.getDepartmentValuesByInstitute(Id),
    enabled: Boolean(Id),
    staleTime: 5000,
  });
}
